import React from "react";

import {FIELD_TYPE, tabKeys, TT_PHIEU_VTYT} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import {listGender} from "../../../../../data/list";
import {trangThaiPKOptions} from "../../../../../assets/constants/select-catagory-options";
import {formatToCurrencyType} from "../../../../../helper/common";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const  allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    dataIndex: "maNhanVien",
    width: 60,
    fixed: "left",
    align: "left",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 130,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Phòng",
    key: "phongBan",
    show: true,
    dataIndex: "phongBan",
    width: 90,
    align: "left",
    isResizable: true,

  },
  {
    title: "Tháng",
    key: "thang",
    show: true,
    dataIndex: "thang",
    width: 90,
    align: "center",
    isResizable: true,
  },
  {
    title: "Năm",
    key: "nam",
    show: true,
    dataIndex: "nam",
    width: 90,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mức lương đóng BHXH",
    key: "mucLuongDongBHXH",
    show: true,
    dataIndex: "mucLuongDongBHXH",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHXH NLĐ đóng",
    key: "bhxhnlddong",
    show: true,
    dataIndex: "bhxhnlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHYT NLĐ đóng",
    key: "bhytnlddong",
    show: true,
    dataIndex: "bhytnlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHTN NLĐ đóng",
    key: "bhtnnlddong",
    show: true,
    dataIndex: "bhtnnlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Nhân viên đóng",
    key: "nvDong",
    show: true,
    dataIndex: "nvDong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },

  },
  {
    title: "BHXH NSDLĐ đóng",
    key: "bhxhnsdlddong",
    show: true,
    dataIndex: "bhxhnsdlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHYT NSDLĐ đóng",
    key: "bhytnsdlddong",
    show: true,
    dataIndex: "bhytnsdlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "BHTN NSDLĐ đóng",
    key: "bhtnnsdlddong",
    show: true,
    dataIndex: "bhtnnsdlddong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Công ty đóng",
    key: "ctyDong",
    show: true,
    isResizable: true,
    dataIndex: "ctyDong",
    width: 90,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },

];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "idPhongBan",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "tuThang",
    label: "Từ tháng",
    disable: false,

    options: listMonths,

  },
  {
    type: COMBO_BOX,
    name: "denThang",
    label: "Đến tháng",
    disable: false,

    options: listMonths,
  },


];

export { allColumns, itemsInputField };
